// VrPage.jsx — one card per Shapespark VR scene; opens in the shared video modal.
import React, { useMemo } from "react";

import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";
import ImageWithFallback from "../components/ImageWithFallback.jsx";
import { useAuth } from "../features/auth";
import { useVideoModal } from "../components/VideoModalContext";
import { useProjects } from "../features/catalog";

import "../features/catalog/catalog.css";

export default function VrPage() {
  const { user, signOut } = useAuth();
  const { openVideo } = useVideoModal();
  const { projects, loading } = useProjects();

  // One card per scene: a project with three VR links becomes three cards.
  // ponytail: flat list for now; group-per-project is a future change (see plan).
  const scenes = useMemo(
    () =>
      projects.flatMap((p) =>
        (p.vr || []).map((url, i) => ({
          key: `${p.id}-${i}`,
          url,
          project: p,
          label: p.vr.length > 1 ? `${p.name} — VR ${i + 1}` : p.name,
        }))
      ),
    [projects]
  );

  const openScene = (scene) =>
    openVideo(scene.url, scene.label, "Shapespark VR walkthrough", { type: "vr" });

  return (
    <div style={sx.page}>
      <Navbar user={user} signOut={signOut} />

      <section className="fpSection">
        <div className="fpContainer">
          <div className="fpHeader">
            <div className="fpHeaderLeft">
              <div className="fpTitleRow">
                <div className="fpTitle">VR</div>
              </div>
              <div className="fpSub">Step into projects in immersive VR</div>
            </div>
          </div>

          {loading ? (
            <div className="fpEmpty">Preparing VR scenes…</div>
          ) : scenes.length === 0 ? (
            <div className="fpEmpty">No VR scenes available yet.</div>
          ) : (
            <div className="fpGrid">
              {scenes.map((scene) => (
                <article key={scene.key} className="fpProjectCard">
                  <div className="fpCardMedia">
                    <ImageWithFallback
                      className="fpCardImg"
                      src={scene.project.thumbnail}
                      alt={scene.label}
                    />
                    <button
                      className="fpViewPill"
                      type="button"
                      onClick={() => openScene(scene)}
                    >
                      View in VR
                    </button>
                  </div>

                  <div className="fpCardDetails">
                    <h3 className="fpProjectName">{scene.label}</h3>
                    <p className="fpProjectMeta">
                      {scene.project.constructionType ||
                        scene.project.industry ||
                        "—"}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

const sx = {
  page: {
    minHeight: "100vh",
    background: "#ffffff",
    color: "#141414",
    fontFamily: "var(--font-sans)",
  },
};
